/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_CLIENTS } from '../../actions.type'
import {
  CREATE_CLIENT,
  REMOVE_CLIENT,
  SET_CLIENT_ALL_REQUEST,
  SET_CLIENT_ALL_VALUE,
  UPDATE_CLIENT
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  clientAllValue: (state) => state.all.value,
  clientAllRequest: (state) => state.all.request,
  clientAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_CLIENTS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('client', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_CLIENT_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_CLIENT_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_CLIENT_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_CLIENT_ALL_VALUE, data)
    } catch (e) {
      commit(SET_CLIENT_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_CLIENT({ commit }, value) {
    commit(CREATE_CLIENT, value)
  },

  async SOCKET_UPDATE_CLIENT({ commit }, value) {
    commit(UPDATE_CLIENT, value)
  },

  async SOCKET_REMOVE_CLIENT({ commit }, id) {
    commit(REMOVE_CLIENT, id)
  }
}

const mutations = {
  [SET_CLIENT_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_CLIENT_ALL_VALUE](state, clients) {
    state.all.value = clients
  },
  [UPDATE_CLIENT](state, updatedClient) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedClient.id }),
      1,
      updatedClient
    )
  },
  [CREATE_CLIENT](state, createdClient) {
    state.all.value.push(createdClient)
  },
  [REMOVE_CLIENT](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
